import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const orderManagementGuard: CanActivateFn = (route, state): Observable<boolean> | Promise<boolean> | boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Combine isAdmin$, isShopeeDocsTeam$, and isShopeeChecker$
  // User can activate if they are admin OR shopee docs team OR shopee checker
  return authService.userRole$.pipe(
    take(1), // Take the first emitted value and complete
    map(role => {
      const normalizedRole = role ? role.toLowerCase() : '';
      const canAccess = normalizedRole === 'admin' ||
                        normalizedRole === 'shopee_docs' ||
                        normalizedRole === 'shopeechecker';

      if (canAccess) {
        return true;
      } else {
        console.warn('OrderManagementGuard: User does not have required role. Redirecting to dashboard.');
        router.navigate(['/dashboard']); // Or a more appropriate "access denied" page
        return false;
      }
    })
  );
};